import React from 'react';

import formatPrice from '~helpers/currency';
import { decode } from 'js-base64';
import Card from '../card';
import moment from 'moment';
import { camelCaseToUpperFirstCase } from '~helpers';
import { startCase } from 'lodash';

const formatPeriod = (start, end) => {
  if (start && end) {
    return `${moment(start).format('MMM DD, YYYY')} - ${moment(end).format('MMM DD, YYYY')}`;
  } else if (start) {
    return `${moment(start).format('MMM DD, YYYY')} - Open-ended`;
  }
  return '-';
};

export default function CommissionInfo({
  t,
  commissionInfo = {},
  showEdit = false,
  setVisibleModal = () => {},
}) {
  const commissionTierPrice = commissionInfo.commissionTierValue
    ? formatPrice(commissionInfo.commissionTierValue, commissionInfo?.currency)
    : '-';

  const commissionTierPercentPrice = commissionInfo.commissionTierValue
    ? commissionInfo?.commissionTierValue + '%'
    : '-';

  const commissionBonusPrice = commissionInfo.bonusCommissionTierValue
    ? formatPrice(commissionInfo.bonusCommissionTierValue, commissionInfo?.currency)
    : '-';

  const commissionBonusPercentPrice = commissionInfo.bonusCommissionTierValue
    ? commissionInfo?.bonusCommissionTierValue + '%'
    : '-';

  const commissionFields = [
    {
      label: t('cms.reconciliation.lead_generation.table.field.commission_tier'),
      value:
        commissionInfo?.commissionTierType === 'PERCENTAGE'
          ? commissionTierPercentPrice
          : commissionTierPrice,
    },
    {
      label: t('cms.reconciliation.lead_generation.table.field.bonus_commission'),
      value:
        commissionInfo?.bonusCommissionTierType === 'PERCENTAGE'
          ? commissionBonusPercentPrice
          : commissionBonusPrice,
    },
    {
      label: t('cms.reconciliation.lead_generation.table.field.total_commission'),
      value: commissionInfo?.totalPrice
        ? formatPrice(commissionInfo.totalPrice, commissionInfo?.currency)
        : '-',
    },
    {
      label: t('cms.reconciliation.lead_generation.table.field.latest_invoice_number'),
      value: commissionInfo?.invoiceNumber,
    },
  ];

  let commissionDataFields = null;
  const commissionTier = commissionInfo?.data?.commission?.commissionData?.tier;
  if (commissionTier) {
    commissionDataFields = [
      {
        label: 'Commission Name',
        value: commissionTier?.name || '-',
      },
      {
        label: 'Commission ID',
        value: JSON.parse(decode(commissionTier?.id))?.id ?? '-',
      },
      {
        label: 'Commission Category',
        value: camelCaseToUpperFirstCase(
          commissionTier?.category?.replace('_', ' ')?.toLowerCase() || '-',
        ),
      },
      {
        label: 'Commission Type',
        value: camelCaseToUpperFirstCase(commissionTier?.type?.toLowerCase() || '-'),
      },
      {
        label: 'Commission Value',
        value: formatPrice(commissionInfo?.totalPrice, commissionInfo?.currency) || '-',
      },
      {
        label: 'Currency',
        value: commissionInfo?.currency || '-',
      },
      {
        label: 'Effective Period',
        value: formatPeriod(commissionTier?.effectiveFrom, commissionTier?.effectiveTo),
      },
      {
        label: 'Commission Trigger Point',
        value: startCase(commissionInfo?.commissionTriggerPoint?.toLowerCase()) || '-',
      },
    ];
  }

  const footer = () => (
    <div className="commission-footer">
      <span className="label">
        {t('cms.reconciliation.lead_generation.update.modal.credit_note_number')}:{' '}
      </span>
      <span className="value">{commissionInfo?.creditNoteNumber ?? '-'}</span>
      <div className="line" />
      <div style={{ display: 'flex', flexWrap: 'nowrap' }}>
        <span className="label">
          {t('cms.reconciliation.lead_generation.update.modal.credit_note_amount')}:{' '}
        </span>
        <span className="value">
          {commissionInfo?.creditNoteAmount
            ? formatPrice(commissionInfo.creditNoteAmount, commissionInfo?.currency)
            : '-'}
        </span>
        <If condition={showEdit}>
          <div className="commission-edit" onClick={() => setVisibleModal(true)}>
            {t('cms.sepcial_offer.edit.btn')}
          </div>
        </If>
      </div>
    </div>
  );

  return (
    <Card
      title={t('cms.reconciliation.lead_generation.detail.commission_info.title')}
      dataSet={commissionFields}
      preDataSet={commissionDataFields}
      footer={footer()}
    />
  );
}
